import { Observable } from 'rxjs'
import { map, pluck } from 'rxjs/operators'

import { Work } from '@skinsoft/types'
import { OfflineDataFetcher } from '@skinsoft/offline'


export class WorkOfflineDataFetcher extends OfflineDataFetcher<Work>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    /*public fetchWemiFromId(id: string): Observable<any> {
        return super.fetchOneFromId(id)
    }*/

    protected idMatcher(entity: any, id: string) {
        if (entity.work) {
            return entity.work.id === id;
        }
        return false;
    }

}